import RequestClass from '@api/request/RequestClass';
import {API_NAMESPACE} from '@constants/general';
import {METHOD_POST} from '@constants/http';

export function reportTypo(url: string, typo: string, context: string, startPosition: number) {
    new RequestClass(`${API_NAMESPACE}/typo`, METHOD_POST)
        .setParams({url, typo, context, startPosition})
        .sendBlind();
}
